import React, { useRef, useState, useEffect, useCallback } from "react";
import { cn } from "../../lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Horizontal scroll container with overlaid left/right arrow buttons (shown only when scrollable).
// Pass `innerClassName` for the scrolling element; children render inside it.
export default function HScroll({ children, innerClassName, step = 380, testid, contentRef }) {
  const scrollRef = useRef(null);
  const [edge, setEdge] = useState({ left: false, right: false });
  const update = useCallback(() => {
    const el = scrollRef.current; if (!el) return;
    setEdge({ left: el.scrollLeft > 4, right: el.scrollLeft + el.clientWidth < el.scrollWidth - 4 });
  }, []);
  useEffect(() => {
    const el = scrollRef.current; if (!el) return;
    update();
    el.addEventListener("scroll", update, { passive: true });
    const ro = new ResizeObserver(update); ro.observe(el);
    window.addEventListener("resize", update);
    return () => { el.removeEventListener("scroll", update); ro.disconnect(); window.removeEventListener("resize", update); };
  }, [update]);
  const go = (dir) => scrollRef.current?.scrollBy({ left: dir * step, behavior: "smooth" });
  return (
    <div className="relative">
      {edge.left && (
        <button onClick={() => go(-1)} data-testid={testid && `${testid}-left`} aria-label="scroll left"
          className="absolute left-1 top-1/2 -translate-y-1/2 z-40 w-9 h-9 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center text-slate-600 hover:text-slate-900 hover:scale-105 transition-all">
          <ChevronLeft className="w-5 h-5" />
        </button>
      )}
      {edge.right && (
        <button onClick={() => go(1)} data-testid={testid && `${testid}-right`} aria-label="scroll right"
          className="absolute right-1 top-1/2 -translate-y-1/2 z-40 w-9 h-9 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center text-slate-600 hover:text-slate-900 hover:scale-105 transition-all">
          <ChevronRight className="w-5 h-5" />
        </button>
      )}
      <div ref={(n) => { scrollRef.current = n; if (contentRef) contentRef.current = n; }} className={cn("overflow-x-auto", innerClassName)}>{children}</div>
    </div>
  );
}
